export default {
    refresh_firmware_title: "Actualizar las versiones de firmware",
    refresh_firmware_question: "¿Desea actualizar las versiones del firmware?",
    refresh_firmware_refresh: "Actualizar",
    refresh_firmware_success_message: "Las versiones del firmware han sido actualizadas",
}